import { useEffect, useState } from 'react';

export function useAnimateScale(ms: number): number {
  const [scale, setScale] = useState(0);
  useEffect(() => {
    const start = Date.now();

    let id = 0;
    const fn = () =>
      requestAnimationFrame(() => {
        const newScale = Math.min((Date.now() - start) / ms, 1);
        setScale(newScale);
        if (newScale !== 1) {
          id = fn();
        }
      });

    id = fn();
    return () => cancelAnimationFrame(id);
  }, [ms]);

  return scale;
}
